import React from 'react'

/**
 * Tools List Component
 * Displays available free tools with links
 */
const ToolsList = ({ translations = {} }) => {
  const t = (key, defaultValue) => translations[key] || defaultValue

  const tools = [
    {
      id: 'chinese-worksheet',
      href: '/tools/chinese-worksheet',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      title: t('chinese_worksheet_title', 'Chinese Character Worksheet Generator'),
      description: t('chinese_worksheet_description', 'Generate practice sheets with Zhuyin, Pinyin, and stroke order for Traditional Chinese characters.'),
      tags: [t('tag_free', 'Free'), t('tag_pdf', 'PDF'), t('tag_zhuyin', 'Zhuyin')]
    },
    {
      id: 'annotate-together',
      href: '/tools/annotate-together',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
        </svg>
      ),
      title: t('annotate_together_title', 'Annotate Together — Screen Annotation Tool'),
      description: t('annotate_together_description', 'Real-time multi-user screen annotation on any webpage. Auto-activates during Google Meet screen share.'),
      tags: [t('tag_free', 'Free'), t('tag_chrome', 'Chrome Extension'), t('tag_collaboration', 'Collaboration')]
    }
  ]

  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {tools.map(tool => (
        <a
          key={tool.id}
          href={tool.href}
          className="group block bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md hover:border-[#3366FF] transition-all cursor-pointer"
        >
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 bg-[#E6F0FF] rounded-lg flex items-center justify-center text-[#3366FF] group-hover:bg-[#3366FF] group-hover:text-white transition-colors">
              {tool.icon}
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-lg font-semibold text-gray-900 group-hover:text-[#3366FF] transition-colors">
                {tool.title}
              </h3>
              <p className="mt-1 text-sm text-gray-600 line-clamp-2">
                {tool.description}
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                {tool.tags.map((tag, idx) => (
                  <span
                    key={idx}
                    className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-700"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </a>
      ))}
    </div>
  )
}

export default ToolsList
